module.exports = __webpack_public_path__ + "assets/img/Blackpurl-Landing-Page-w540.e88e7fef.jpg";